import { render, staticRenderFns } from "./ChoiceAutocompleteField.vue?vue&type=template&id=2471dea4"
import script from "./ChoiceAutocompleteField.vue?vue&type=script&lang=ts"
export * from "./ChoiceAutocompleteField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports